import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { WIDGET_VIEW_TYPES } from "@cld/upload-widget";
import { types as ats } from "root/actions";

const useExpandedView = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({
			type: ats.SET_WIDGET_VIEW_TYPE,
			payload: { type: WIDGET_VIEW_TYPES.EXPANDED }
		});
	}, [dispatch]);
};

export default useExpandedView;
